import { LuTrophy } from "react-icons/lu";
import * as styled from "./ProgressBlock.styled"
import { getCurrentLevel, getNextLevel } from "../../../helpers/lessonsLevels/lessonsLevels";

function ProgressBlock({ data, levels, isTrial }) {
  const lessons = isTrial ? 0 : data.lessonsLevel;
  const currentLevel = getCurrentLevel(lessons, levels);
  const nextLevel = getNextLevel(currentLevel, levels);
  const progressToNextLevel = lessons - currentLevel.value;
  const progressPercentage = Math.min(100, (progressToNextLevel / (nextLevel.value - currentLevel.value)) * 100);
  const left = Math.max(0, nextLevel.value - lessons);

  return (
    <styled.ProgressWrapper>
      <styled.Header>
        <styled.IconWrapper>
          <LuTrophy size={20} />
        </styled.IconWrapper>
        <div>
          <styled.ProgressTitle>Мій прогрес</styled.ProgressTitle>
          <styled.LevelName>{currentLevel.name}</styled.LevelName>
        </div>
      </styled.Header>

      <styled.ProgressText>
        {lessons}
        <span> / {nextLevel.value} уроків</span>
      </styled.ProgressText>

      <styled.ProgressBar>
        <styled.ProgressBarFill style={{ width: `${progressPercentage}%` }} />
      </styled.ProgressBar>

      <styled.Hint>
        {left > 0 ? (
          <>Ще {left} до рівня <b>«{nextLevel.name}»</b></>
        ) : (
          <>Рівень <b>«{nextLevel.name}»</b> вже близько</>
        )}
      </styled.Hint>
    </styled.ProgressWrapper>
  )
};

export default ProgressBlock;
